import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <header className="sticky top-0 z-50 bg-white shadow-md" data-id="element-131">
      <div className="container mx-auto px-4 py-3" data-id="element-132">
        <nav className="flex items-center justify-between" data-id="element-133">
          <div className="flex items-center" data-id="element-134">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hYfcvFkA5ig3Y9Rk5E8PSp/LOGO_LANDING.png" alt="Guaterflow Logo" className="h-12" data-id="element-135" />
          </div>
          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-136">
            <a href="#inicio" className="text-gray-700 hover:text-[#2d98e2] transition-colors" data-id="element-137">
              Inicio
            </a>
            <a href="#planes" className="text-gray-700 hover:text-[#2d98e2] transition-colors" data-id="element-138">
              Planes
            </a>
            <a href="#como-funciona" className="text-gray-700 hover:text-[#2d98e2] transition-colors" data-id="element-139">
              Cómo Funciona
            </a>
            <a href="#impacto-social" className="text-gray-700 hover:text-[#2d98e2] transition-colors" data-id="element-140">
              Impacto Social
            </a>
            <a href="#contacto" className="text-gray-700 hover:text-[#2d98e2] transition-colors" data-id="element-141">
              Contacto
            </a>
            <button className="bg-[#2d98e2] hover:bg-[#146ead] text-white font-medium py-2 px-4 rounded-lg transition-colors" data-id="element-142">
              Suscríbete ahora
            </button>
          </div>
          {/* Mobile menu button */}
          <button className="md:hidden text-gray-700" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-143">
            {isMenuOpen ? <XIcon size={24} data-id="element-144" /> : <MenuIcon size={24} data-id="element-145" />}
          </button>
        </nav>
        {/* Mobile Navigation */}
        {isMenuOpen && <div className="md:hidden pt-4 pb-2" data-id="element-146">
            <div className="flex flex-col space-y-3" data-id="element-147">
              <a href="#inicio" className="text-gray-700 hover:text-[#2d98e2] transition-colors py-2" data-id="element-148">
                Inicio
              </a>
              <a href="#planes" className="text-gray-700 hover:text-[#2d98e2] transition-colors py-2" data-id="element-149">
                Planes
              </a>
              <a href="#como-funciona" className="text-gray-700 hover:text-[#2d98e2] transition-colors py-2" data-id="element-150">
                Cómo Funciona
              </a>
              <a href="#impacto-social" className="text-gray-700 hover:text-[#2d98e2] transition-colors py-2" data-id="element-151">
                Impacto Social
              </a>
              <a href="#contacto" className="text-gray-700 hover:text-[#2d98e2] transition-colors py-2" data-id="element-152">
                Contacto
              </a>
              <button className="bg-[#2d98e2] hover:bg-[#146ead] text-white font-medium py-2 px-4 rounded-lg transition-colors w-full mt-2" data-id="element-153">
                Suscríbete ahora
              </button>
            </div>
          </div>}
      </div>
    </header>;
};
export default Navigation;